import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/benchmarkStudy/importer/benchmarkStudyImporterActions';

export default importerReducers(actions);
